import DisqusToggle from './disqusToggle';

const disqusToggleConfig = {
  name: 'disqusToggle',
  class: DisqusToggle,
  querySelector: {
    controller: '.longform-section-title__toggle--disqus',
  },
};

export default disqusToggleConfig;
